import React, { useEffect, useRef } from "react";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

export function PlyrVideo({ videoUrl }) {
  const playerRef = useRef(null);

  useEffect(() => {
    if (playerRef.current) {
      const player = new Plyr(playerRef.current, {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "fullscreen",
        ],
        youtube: {
          noCookie: true,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          quality: "2160p",
          playsinline: 1,
          controls: 0,
          origin: window.location.origin,
        },
        hideControls: false,
      });

      player.on("ended", (event) => {
        player.restart();
        setTimeout(() => {
          player.pause();
        }, 10);
      });

      // Apply custom styles
      const style = document.createElement("style");
      style.textContent = `
        .plyr--full-ui input[type=range] {
          color: #4c00ff;
        }
        .plyr__control--overlaid {
          background: rgba(76, 0, 255, 0.8);
        }
        .plyr--video .plyr__control:hover {
          background: #4c00ff;
        }
        .plyr--video .plyr__control.plyr__tab-focus,
        .plyr--video .plyr__control:hover,
        .plyr--video .plyr__control[aria-expanded=true] {
          background: #4c00ff;
        }
        .plyr__control.plyr__tab-focus {
          box-shadow: 0 0 0 5px rgba(139, 92, 246, 0.5);
        }
        .plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]::before {
          background: #4c00ff;
        }
      `;
      document.head.appendChild(style);

      return () => {
        player.destroy();
        document.head.removeChild(style);
      };
    }
  }, []);

  return (
    <div
      className="aspect-video w-full relative z-0"
      ref={playerRef}
      id="youtube-player"
    >
      <iframe
        src={`${videoUrl}?origin=https://plyr.io&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1&amp;vq=hd2160&amp;controls=0`}
        className="w-full h-full"
        allowFullScreen
        allow="autoplay"
      ></iframe>
    </div>
  );
}
